import React from "react";

const CaretDown = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.5306 6.53062L8.5306 11.5306C8.46092 11.6005 8.37813 11.656 8.28696 11.6939C8.1958 11.7317 8.09806 11.7512 7.99935 11.7512C7.90064 11.7512 7.8029 11.7317 7.71173 11.6939C7.62057 11.656 7.53778 11.6005 7.4681 11.5306L2.4681 6.53062C2.3272 6.38973 2.24805 6.19863 2.24805 5.99937C2.24805 5.80012 2.3272 5.60902 2.4681 5.46812C2.60899 5.32723 2.80009 5.24807 2.99935 5.24807C3.19861 5.24807 3.3897 5.32723 3.5306 5.46812L7.99997 9.9375L12.4693 5.4675C12.6102 5.3266 12.8013 5.24745 13.0006 5.24745C13.1999 5.24745 13.391 5.3266 13.5318 5.4675C13.6727 5.6084 13.7519 5.79949 13.7519 5.99875C13.7519 6.19801 13.6727 6.3891 13.5318 6.53L13.5306 6.53062Z" fill="#6F787E"/>
  </svg>
}

export default CaretDown;
